import { useEffect, useRef } from 'react';
import { useAuth } from '../auth/useAuth';
import { attachBrowserLiveOwner } from '../api/chatClient';

/** Keep token refresh current without giving a detached SDK a different account's token. */
export function useBrowserLiveOwner(conversationId?: string): void {
  const auth = useAuth();
  const current = useRef(auth);
  current.current = auth;
  const settledAccountId = useRef(auth.account?.homeAccountId);
  if (!auth.isAuthPending) settledAccountId.current = auth.account?.homeAccountId;
  const accountId = settledAccountId.current;
  const owner = useRef({ conversationId, accountId });
  owner.current = { conversationId, accountId };

  useEffect(() => {
    if (!conversationId) return;
    const detach = attachBrowserLiveOwner(conversationId, async () => {
      if (current.current.account?.homeAccountId !== accountId) {
        throw new DOMException('Identity changed.', 'AbortError');
      }
      const token = current.current.isSignedIn ? await current.current.acquireApiToken() : null;
      if (current.current.account?.homeAccountId !== accountId) {
        throw new DOMException('Identity changed.', 'AbortError');
      }
      return token;
    });
    return () => detach(owner.current.accountId !== accountId || owner.current.conversationId !== conversationId);
  }, [conversationId, accountId]);
}
